export const TASK_STATUSES = [
  'Pendiente',
  'En progreso',
  'Recurrente',
  'Bloqueada',
  'En espera de cliente',
  'En espera de usuario/Presidencia',
  'Lista para revisión',
  'Devuelta / Requiere ajustes',
  'Aprobada / Cerrada',
  'No realizada',
];

export const TASK_PRIORITIES = [
  'Crítica',
  'Alta',
  'Media',
  'Baja'
];

export const ROLES = {
  PRESIDENCIA: 'Presidencia',
  GERENCIA: 'Gerencia',
  USUARIO: 'Usuario'
};